import { z } from 'zod';
import { permissionSchema } from '#src/auth/permissions.contract.js';
/**
 * Pessoa autenticada pelo SSO do Teams (ou, fora de produção, pelo modo dev).
 * Não há integrações (M2M): quem chama a API é sempre uma pessoa.
 */
export const sessionUserSchema = z.strictObject({
    id: z.uuid(),
    name: z.string(),
    email: z.string(),
    /** Códigos dos perfis da pessoa. Sem perfil, não há permissão nenhuma. */
    roles: z.array(z.string()),
});
/** Resposta de `GET /api/auth/me`: quem está chamando e o que pode fazer. */
export const sessionSchema = z.strictObject({
    user: sessionUserSchema,
    permissions: z.array(permissionSchema),
});
//# sourceMappingURL=session.contract.js.map